<template>
    <div class='back-home'>
        <div class="home-item" v-for='data in choice' :key='data.name'>
            <div class="home-head">
                <span class='text'>{{ data.text }}</span>
                <div class="icon">
                    <img :src=" data.icon | menuIcon">
                </div>
            </div>
            <div class='home-wrap'>
                <div class='text' v-for='item in getSecondMenu(data)' :key='item.name' @click='link(item.name)' >{{ item.text }}</div>
            </div>
        </div>
    </div>
</template>

<script> 
    import backRouter from "src/config/router-back-config.js"
    import { mapGetters } from "vuex"

    export default {
        computed:{
            ...mapGetters(['codeList']),
            choice(){  //选项
                return backRouter.children.filter(item=>{
					item.meta = item.meta || {};
					return item.meta.code == undefined || this.codeList.some(code=> code == item.meta.code); 
				})
            },
        },
        methods:{
            getSecondMenu:(function(){  //构造二级菜单
                const map = new Map();
                return function(data){
                    let list = map.get(data);
                    if(list){
                        return list;
                    }

                    list = data.children || [];
                    list = list.filter(choice=>{
                        choice.meta = choice.meta || {};
                        let arr = [
                            choice.meta.code == undefined,
                            this.codeList.some(code=>code == choice.meta.code),
                        ]
                        return  choice.secondMenu == true && arr.some(val=>val);
                    });
                    map.set(data,list);
                    return list;
                }
            })(),
            link(name){
                this.$router.push({name:name});
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    .back-home{
        padding: 50px 0 0 50px;
        overflow: hidden;
    }

    @bg:#e1edfa;

    // 块
    .home-item{
        background:#fff;
        box-shadow:0 0 4px 0 rgba(141,141,141,0.50);
        border-radius:8px;
        width:220px;
        height:200px;
        font-size: 14px;
        overflow: hidden;
        margin-right:30px;
        margin-bottom: 40px;
        float: left;

 
        // 头部
        .home-head{
            background:@bg;
            height: 50px;
            font-weight: 600;
            position: relative;
            .text{
                line-height: 70px;
            }
            .icon{
                position: absolute;
                height: 46px;
                width:46px;
                border-radius: 50%;
                border:2px solid #fff;
                box-sizing: border-box;
                background:@bg;
                right: 15px;
                top:15px;

                img{
                    position: absolute;
                    left: 50%;
                    top:50%;
                    transform: translate(-50%,-50%);
                }
            }
        }

        // 主体
        .home-wrap{
            position: relative;
            top:calc(~"(100% - 50px)/2");
            transform: translateY(-50%);
        }

        // 文字
        .text{  
            position: relative;
            color:#637180;
            transition: 0.3s;
            cursor: pointer;
            &:before{
                content:"";
                height: 4px;
                width:4px;
                border-radius: 50%;
                background:#637180;
                display:inline-block;
                margin: 0 10px 0 20px;
                vertical-align: middle;
            }

            &:hover{
                color:@blue;
                &:before{
                    background:@blue;
                }
            }
        }  
    }
</style>


// WEBPACK FOOTER //
// home.vue?573be62f